type Action = 'link_click'

type EventName = 'main_cta_get_started'

export type PaidSearchBrandTrackingEventType = {
  action: Action
  properties: {
    component_name: EventName
  }
}

export const heroGetStartedTrackingEvent = (): PaidSearchBrandTrackingEventType => ({
  action: 'link_click',
  properties: {
    component_name: 'main_cta_get_started',
  },
})
